import React, { useEffect, useState } from "react";
import { Collapse } from "reactstrap";
import { connect } from "react-redux";
import { v4 } from 'uuid';
import Icon from '@mdi/react';

import OffertForm from "./OffertForm";
import { getBrands, getModels } from "../../../../redux/actions/spiderActions";
import { getMyOfferts, resetMyOfferts } from "../../../../redux/actions/offeringActions";

import { mdiChevronRight, mdiChevronDown, mdiPlus, mdiDeleteForeverOutline } from '@mdi/js';
import { map, remove } from "lodash";
import { vehicleTypeFormatter } from "../../../../helper/functions";
import { isUserAllowed } from "../../../../shared/utils";

const initialOffertData = {
  brand: '',
  brandId: '',
  modelsCache: [],
  model: '',
  version: '',
  year: '',
  vehiclePrice: '',
  vehicleType: '',
  kilometers: '',
  carChannel: '',
  comment: ''
}

const OffertComponent = ({
  offertHandler,
  getMyOfferts,
  resetMyOfferts,
  getBrands,
  getModels,
  quotationId,
  carFound,
  myOfferts,
  brands,
  models
}) => {

  const { offertData, setOfferts } = offertHandler;

  const [openCollapse, setOpen] = useState('');

  useEffect(() => { getMyOfferts(quotationId) }, [getMyOfferts, quotationId]);
  useEffect(() => { return () => resetMyOfferts() }, [resetMyOfferts]);

  const handleCollapseToggle = (id) => {
    setOpen((openCollapse === id) ? '' : id);
  }

  const offertMaxValidation = () => {
    if (isUserAllowed('admin')) {
      return 0;
    } else {
      return myOfferts.data ? (myOfferts.data.length + offertData.length) : offertData.length;
    }
  }

  const handleAddOffert = () => {
    if (offertMaxValidation() < 2) {
      let allOffert = [...offertData];
      allOffert.push({ ...initialOffertData, id: v4(), quotation: quotationId });
      setOfferts(allOffert);
    }
  };

  const onChangeOffert = (offert, key) => {
    setOfferts((currentOffert) => map(currentOffert, (e) => (
      e.id === offert.id ? { ...e, [key]: offert[key] } : e
    )));
  };

  const handleRemoveOffert = (id) => {
    let allOffert = [...offertData];
    remove(allOffert, (e) => e.id === id);
    setOfferts(allOffert);
  }

  const handleVehicleType = (offert, vehicleType, key) => {
    onChangeOffert({ ...offert, vehicleType }, key);
    getBrands(vehicleTypeFormatter(vehicleType));
  }

  return (
    <div className="crm-modal-adjudge-container">
      {map(offertData, (e, index) =>
        <div className="crm-modal-adjudge-collapse-container">
          <div className="crm-modal-collapse-actions">
            <div className="crm-adjudge">
              <button type="button" onClick={() => handleCollapseToggle(e.id)}>
                <Icon path={e.id === openCollapse ? mdiChevronDown : mdiChevronRight} size={0.9} />
                {`Oferta ${index + 1}`}
              </button>
              <button className="crm-remove-btn" type="button" onClick={() => handleRemoveOffert(e.id)}>
                <Icon path={mdiDeleteForeverOutline} size={0.8} />
              </button>
            </div>
          </div>
          <Collapse isOpen={e.id === openCollapse}>
            <OffertForm
              offert={e}
              getModels={getModels}
              onChangeOffert={onChangeOffert}
              handleVehicleType={handleVehicleType}
              brands={brands}
              models={models}
            />
          </Collapse>
        </div>
      )}
      {myOfferts.data && myOfferts.data.length >= 2 && !isUserAllowed('admin') &&
        <div className="crm-modal-max-offerts">No se puede hacer más ofertas a ésta cotización</div>
      }
      {offertMaxValidation() < 2 && carFound &&
        <div className="crm-adjudge-add">
          <button type="button" className="crm-modal-add-adjudge-btn" onClick={handleAddOffert} disabled={offertMaxValidation() >= 2}>
            Adherir Oferta
            <Icon path={mdiPlus} size={0.8} />
          </button>
        </div>
      }
    </div>
  )
}

const mapStateToProps = ({ spider, offering }) => ({
  brands: spider.brands,
  models: spider.models,
  myOfferts: offering.myOfferts
});

const mapDispatchToProps = {
  getBrands,
  getModels,
  resetMyOfferts,
  getMyOfferts,
};

export default connect(mapStateToProps, mapDispatchToProps)(OffertComponent);